import { ImageAiType } from '@ev-tech/search-modules-api';

import { type TFunction } from '../providers/AppContextProvider';

export const DEFAULT_IMAGE_ALT = 'property image';

type GetImageAltWithAiIndicatorProps = {
  baseAlt: string | undefined;
  imageAiType: ImageAiType | undefined;
  t: TFunction;
};

export const getImageAltWithAiIndicator = ({ baseAlt, imageAiType, t }: GetImageAltWithAiIndicatorProps): string => {
  const alt = baseAlt || DEFAULT_IMAGE_ALT;

  let indicator: string | undefined;
  if (imageAiType === ImageAiType.GENERATED) {
    indicator = t('search.image.alt.aiGenerated');
  } else if (imageAiType === ImageAiType.MODIFIED) {
    indicator = t('search.image.alt.aiModified');
  }

  return indicator ? `${alt} [${indicator}]` : alt;
};
